module.exports = __webpack_public_path__ + "media/images/svg/logo-af8f324e1e68863ae55fbcd84f65e3e7.svg";